var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-container',[_c('contest-forms-view-panel',{on:{"form-deleted":_vm.formDeleted,"form-chosen":_vm.formChosen}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }